import {useContext} from 'react';
import {Icon} from '@bonprix/design-system';
import {HeaderContext} from '@header/scripts/components/context/HeaderContext.jsx';
import MessageBroker from 'deprecated-shared-ui/components/message-broker.js';

export default function HamburgerMenu({className = ''}) {
    const {headerLightMode, mobileNaviOpened, openMobileNavi, closeMobileNavi} = useContext(HeaderContext);

    const handleClick = () => {
        const willOpen = !mobileNaviOpened;
        if (willOpen) {
            MessageBroker.publish("PRODUCT.HIDE_STICKY_BUTTON", {hideStickyAddToBagButton: true});
            openMobileNavi();
        } else {
            MessageBroker.publish("PRODUCT.MAKE_BUTTON_STICKY", {hideStickyAddToBagButton: false});
            closeMobileNavi();
        }
    };

    const iconVariant = mobileNaviOpened ? 'closer' : 'menu';

    return (
        <button className={`hamburger-menu__icon-wrapper ${className}`} onClick={handleClick} aria-label="Navigation">
            <Icon variant={iconVariant} className={`${headerLightMode ? 'fill-clr-on-primary-high' : ''}`} />
        </button>
    );
}
